import React, { useState } from 'react';
import { ShieldIcon, PhoneIcon, MenuIcon, XIcon } from 'lucide-react';
import { useModal } from '../App';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    openModal
  } = useModal();
  const navLinks = [{
    name: 'Services',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Gallery',
    href: '#'
  }, {
    name: 'Financing',
    href: '#'
  }, {
    name: 'Contact',
    href: '#'
  }];
  return <nav className="sticky top-0 z-50 w-full bg-slate-900 border-b border-slate-800" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="flex justify-between items-center h-20" data-id="element-232">
          <div className="flex items-center gap-3" data-id="element-233">
            <div className="bg-amber-500 p-2 rounded-lg" data-id="element-234">
              <ShieldIcon className="h-6 w-6 text-white" data-id="element-235" />
            </div>
            <div className="flex flex-col" data-id="element-236">
              <span className="text-2xl font-bold text-white leading-none tracking-tight" data-id="element-237">ProRoof</span>
              <span className="text-xs text-slate-400 font-medium mt-1 uppercase tracking-wider" data-id="element-238">Roofing, Done Right</span>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-8" data-id="element-239">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-slate-300 hover:text-amber-500 text-sm font-medium transition-colors duration-200" data-id="element-240">
                {link.name}
              </a>)}
          </div>

          <div className="hidden md:flex items-center gap-6" data-id="element-241">
            <div className="flex items-center gap-2 text-white" data-id="element-242">
              <PhoneIcon className="h-5 w-5 text-amber-500" data-id="element-243" />
              <span className="font-semibold text-lg" data-id="element-244">(555) 000-0000</span>
            </div>
            <button onClick={openModal} className="bg-amber-500 hover:bg-amber-600 text-white px-6 py-2.5 rounded-lg font-semibold transition-colors shadow-lg shadow-amber-500/20" data-id="element-245">
              Get Free Quote
            </button>
          </div>

          <div className="md:hidden flex items-center" data-id="element-246">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-300 hover:text-white p-2" aria-label="Toggle menu" data-id="element-247">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-248" /> : <MenuIcon className="h-6 w-6" data-id="element-249" />}
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && <div className="md:hidden bg-slate-900 border-t border-slate-800" data-id="element-250">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-251">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-medium text-slate-300 hover:text-amber-500 hover:bg-slate-800 rounded-md" data-id="element-252">
                {link.name}
              </a>)}
            <div className="mt-6 pt-6 border-t border-slate-800 flex flex-col gap-4 px-3" data-id="element-253">
              <div className="flex items-center gap-2 text-white justify-center" data-id="element-254">
                <PhoneIcon className="h-5 w-5 text-amber-500" data-id="element-255" />
                <span className="font-semibold text-lg" data-id="element-256">(555) 000-0000</span>
              </div>
              <button onClick={openModal} className="w-full bg-amber-500 hover:bg-amber-600 text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-257">
                Get Free Quote
              </button>
            </div>
          </div>
        </div>}
    </nav>;
}